import { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { collection, onSnapshot, doc, setDoc } from "firebase/firestore";

export function useContacts() {
    const [contacts, setContacts] = useState({});
    const [loading, setLoading] = useState(true);
    const currentUser = auth.currentUser;

    useEffect(() => {
        if (!currentUser) {
            setContacts({});
            setLoading(false);
            return;
        }

        const unsub = onSnapshot(
            collection(db, "users", currentUser.uid, "contacts"),
            (snap) => {
                const map = {};
                snap.docs.forEach((d) => {
                    map[d.id] = d.data().alias;
                });
                setContacts(map);
                setLoading(false);
            },
            (err) => {
                console.error("Error fetching contacts:", err);
                setLoading(false);
            }
        );

        return () => unsub();
    }, [currentUser]);

    const updateContact = async (uid, alias) => {
        if (!currentUser) return;
        try {
            if (!alias || alias.trim() === "") {
                // Could delete doc if empty, or just set to empty string.
                // Let's set it. If we want to "remove" alias, we might want deleteDoc.
                // For now, allow setting.
            }
            await setDoc(doc(db, "users", currentUser.uid, "contacts", uid), {
                alias: alias,
                updatedAt: new Date()
            }, { merge: true });
        } catch (e) {
            console.error("Failed to update contact:", e);
            throw e;
        }
    };

    return { contacts, loading, updateContact };
}
